import React from "react";

import BaseField, { BaseFieldProps } from "./BaseField";

import { PressableWithFocus } from "./PressableWithFocus";

type ButtonFieldProps = Omit<BaseFieldProps, "component" | "hasValue" | "value"> & {
    text?: string;
    info?: React.ReactNode;
    onPress?: () => void;
};

const ButtonField = ({
    text,
    onPress,
    asListAction,
    isSelfContained,
    label,
    style,
    error,
    left,
    placeholder,
    right,
    numberOfLines,
    testID,
    info,
    valueColor,
    ...props
}: ButtonFieldProps) => {
    return (
        <>
            <BaseField
                value={text}
                asListAction={asListAction}
                label={label}
                placeholder={placeholder}
                right={right}
                valueColor={valueColor}
                left={left}
                style={style}
                error={error}
                disabled={props.disabled}
                numberOfLines={numberOfLines}
                isSelfContained={isSelfContained}
                asButton
                info={info}
                component={
                    <PressableWithFocus
                        testID={testID}
                        disabled={props.disabled}
                        onPress={onPress}
                    />
                }
            />
        </>
    );
};

export default ButtonField;
